import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
    {
        path: '/',
        name: 'index',
        component: () => import(/* webpackChunkName: "err" */ '@/views/Index'),
        meta: {
            requiresAuth: false,
        },
        children: [
            {
                path: '/repair',
                name: 'repair',
                component: () => import(/* webpackChunkName: "err" */ '@/views/repair/index'),
                meta: {
                    requiresAuth: false,
                },
            },
            {
                path: '/refurbishment',
                name: 'refurbishment',
                component: () => import(/* webpackChunkName: "err" */ '@/views/refurbishment/index'),
                meta: {
                    requiresAuth: false,
                },
            },
            {
                path: '/goods',
                name: 'goods',
                component: () => import(/* webpackChunkName: "err" */ '@/views/goods/index'),
                meta: {
                    requiresAuth: false,
                },
            },
           
            {
                path: '/brief',
                name: 'brief',
                component: () => import(/* webpackChunkName: "err" */ '@/views/brief/index'),
                meta: {
                    requiresAuth: false,
                },
            },
            {
                path: '/mine',
                name: 'mine',
                component: () => import(/* webpackChunkName: "err" */ '@/views/mine/index'),
                meta: {
                    requiresAuth: false,
                },
            },
        ]
    },
    {
        path: '/repairDetail',
        name: 'repairDetail',
        component: () => import(/* webpackChunkName: "err" */ '@/views/repair/detail'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/refurbishmentDetail',
        name: 'refurbishmentDetail',
        component: () => import(/* webpackChunkName: "err" */ '@/views/refurbishment/detail'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/myAppointment',
        name: 'myAppointment',
        component: () => import(/* webpackChunkName: "err" */ '@/views/mine/myAppointment'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/evaluate',
        name: 'evaluate',
        component: () => import(/* webpackChunkName: "err" */ '@/views/mine/evaluate'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/Login',
        name: 'Login',
        component: () => import(/* webpackChunkName: "err" */ '@/views/Login'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/register',
        name: 'register',
        component: () => import(/* webpackChunkName: "err" */ '@/views/register'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/resetPassword',
        name: 'resetPassword',
        component: () => import(/* webpackChunkName: "err" */ '@/views/resetPassword'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/appointment',
        name: 'appointment',
        component: () => import(/* webpackChunkName: "err" */ '@/views/appointment'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/leavingMessage',
        name: 'leavingMessage',
        component: () => import(/* webpackChunkName: "err" */ '@/views/leavingMessage/index'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/welcome',
        name: 'welcome',
        component: () => import(/* webpackChunkName: "err" */ '@/views/welcome'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/conceal',
        name: 'conceal',
        component: () => import(/* webpackChunkName: "err" */ '@/views/conceal'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/shouldKnow',
        name: 'shouldKnow',
        component: () => import(/* webpackChunkName: "err" */ '@/views/shouldKnow'),
        meta: {
            requiresAuth: false,
        },
    },
    {
        path: '/goodsDetail',
        name: 'goodsDetail',
        component: () => import(/* webpackChunkName: "err" */ '@/views/goods/detail'),
        meta: {
            requiresAuth: false,
        },
    },

];

const router = new Router({
    base: '/',
    routes,
});

router.beforeEach((to, from, next) => {
    let userInfo = localStorage.getItem('userInfo')||'{}';
    let info = JSON.parse(userInfo);
    if(!Object.keys(info).length){
        if(to.path === '/login'||to.path === '/welcome'||to.path === '/resetPassword'||to.path === '/register'||to.path ==='/conceal'||to.path ==='/shouldKnow'){
            next();
        }else {
            router.push('/welcome');
        }
    }
    next();
});

export default router;
